(function () {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputMultiStateCheckbox', cpInputMultiStateCheckbox);

    cpInputMultiStateCheckbox.$inject = ['$compile'];

    function cpInputMultiStateCheckbox($compile) {

        return {
            restrict: 'E',
            replace: true,
            require: 'ngModel',
            templateUrl: 'app/caffeprint/directives/input-multi-state-checkbox/input-multi-state-checkbox.html',
            scope: {
                isThreeState: '=',
                label: '=',
                isDisabled: '=',
                helpText: '='
            },
            link: function (scope, element, attrs, ngModel) {
                var states,
                    classNames;
                if (scope.isThreeState) {
                    states = [true, false, null];
                    classNames = ["checked", "unchecked", "clear"];
                } else {
                    states = [true, false];
                    classNames = ["checked", "unchecked"];
                }

                scope.click = function () {
                    if (scope.isDisabled) return;
                    var st;
                    states.map(function (val, i) {
                        if (ngModel.$modelValue === val) {
                            st = states[(i + 1) % states.length];
                        }
                    });
                    ngModel.$setViewValue(st);
                    ngModel.$render();
                };

                scope.mscClassName = function () {
                    var className;
                    if (scope.isThreeState) {
                        className = 'three-state ';
                    } else {
                        className = ''
                    }
                    if (scope.isDisabled) className += 'disabled ';
                    states.map(function (val, i) {
                        if (ngModel.$modelValue === val) {
                            className += classNames[i];
                        }
                    });
                    return className;
                };

            }
        }
    }

})();
